// Which of the site's languages to offer a visitor, from the browser's
// language list. Pure, so `yarn test:lib` can check it; the language-suggest
// controller feeds it the language switcher's links and navigator.languages.
//
// - A browser language matches one of ours by its primary subtag: es-ES and
//   es match es-MX, pt-PT matches pt-BR, en-GB matches en.
// - When the page's own language is anywhere in the browser's list there is
//   nothing to offer: the visitor reads it, whatever else they read.
// - Otherwise the first browser language the site has wins.

export function primary(tag) {
  return String(tag || "").toLowerCase().split("-")[0]
}

// alternates: the switcher's links, [{ lang: "es-MX", url: "/es/pricing/",
// current: false }, ...]; browserLanguages: navigator.languages. Returns the
// alternate to offer, or null.
export function suggestLanguage(alternates, browserLanguages) {
  const current = alternates.find((alt) => alt.current)
  if (!current) return null
  const wanted = Array.from(browserLanguages || []).map(primary).filter(Boolean)
  if (wanted.includes(primary(current.lang))) return null
  for (const tag of wanted) {
    const match = alternates.find((alt) => primary(alt.lang) === tag)
    if (match) return match
  }
  return null
}

// What the toast says, in the language it offers. Every language in
// _data/translations.yml needs an entry (the test checks); a language without
// one is never offered.
export const STRINGS = {
  en: { message: "This site is available in English.", link: "View in English", close: "Close" },
  es: { message: "Este sitio está disponible en español.", link: "Ver en español", close: "Cerrar" },
  pt: { message: "Este site está disponível em português.", link: "Ver em português", close: "Fechar" },
  ja: { message: "このサイトは日本語でもご覧いただけます。", link: "日本語で表示", close: "閉じる" },
  de: { message: "Diese Seite gibt es auch auf Deutsch.", link: "Auf Deutsch ansehen", close: "Schließen" },
  fr: { message: "Ce site est disponible en français.", link: "Voir en français", close: "Fermer" },
  it: { message: "Questo sito è disponibile in italiano.", link: "Visualizza in italiano", close: "Chiudi" },
  id: { message: "Situs ini tersedia dalam bahasa Indonesia.", link: "Lihat dalam bahasa Indonesia", close: "Tutup" },
  ko: { message: "이 사이트는 한국어로도 볼 수 있어요.", link: "한국어로 보기", close: "닫기" },
  el: { message: "Αυτός ο ιστότοπος είναι διαθέσιμος στα ελληνικά.", link: "Προβολή στα ελληνικά", close: "Κλείσιμο" },
}

export function stringsFor(lang) {
  return STRINGS[primary(lang)] || null
}
